import { Component } from 'react';
import PropTypes from 'prop-types';
import IgniteDataTable from '../../common/datatable';

export default class NotificationTable extends Component {
  static propTypes = {
    actions: PropTypes.array,
    title: PropTypes.string.isRequired,
    notifications: PropTypes.array.isRequired,
  };

  static defaultProps = {
    actions: [],
  };

  render() {
    const {
      actions, title, notifications, paging, currentPage, onPageChange
    } = this.props;

    const {number, size} = paging;
    const dataSize = number * size;
    const pagination = {
      page: currentPage,
      sizePerPage: size,
      onPageChange,
    };

    const columns = [
      {
        prop: title.toLowerCase(),
        width: '70%',
        title,
      },
    ];

    return (
      <div>
        <IgniteDataTable
          actions={actions}
          columns={columns}
          data={notifications}
          dataSize={dataSize}
          pagination={pagination}
          hasAttributes={false}
          remote
          hideId
        />
      </div>
    );
  }
}

